if (!customElements.get('recently-viewed-products')) {
  customElements.define(
    'recently-viewed-products',
    class RecentlyViewedProducts extends HTMLElement {
      connectedCallback() {
        this.storageKey = 'jmpus:recently-viewed';
        this.maxStored = 12;
        this.recordCurrentProduct();
        this.render();
      }

      recordCurrentProduct() {
        const recordEl = this.querySelector('[data-recently-viewed-record]');
        if (!recordEl) return;

        let product;
        try {
          product = JSON.parse(recordEl.textContent);
        } catch (error) {
          return;
        }
        if (!product || !product.handle) return;

        const stored = this.getStored().filter((item) => item.handle !== product.handle);
        stored.unshift(product);
        this.setStored(stored.slice(0, this.maxStored));
      }

      getStored() {
        try {
          const raw = window.localStorage.getItem(this.storageKey);
          return raw ? JSON.parse(raw) : [];
        } catch (error) {
          return [];
        }
      }

      setStored(items) {
        try {
          window.localStorage.setItem(this.storageKey, JSON.stringify(items));
        } catch (error) {
          // Recently viewed remains optional when storage is unavailable.
        }
      }

      render() {
        const currentHandle = this.dataset.currentHandle || null;
        const maxItems = parseInt(this.dataset.maxItems, 10) || 4;
        const items = this.getStored()
          .filter((item) => item.handle !== currentHandle)
          .slice(0, maxItems);
        const list = this.querySelector('.recently-viewed__list');

        if (!list || items.length === 0 || !window.JmpusProductCard) return;

        Promise.all(items.map((item) => this.buildCard(item))).then((nodes) => {
          nodes.forEach((node) => list.appendChild(node));
          this.classList.add('recently-viewed--has-items');
        });
      }

      // Prefers the real, always-current card fetched from the product's own
      // page (see product-card-client.js `fetchRealCard`); falls back to the
      // hand-built approximation only if that fetch fails (offline, etc.).
      buildCard(item) {
        const fallback = () =>
          window.JmpusProductCard.buildListItem(item, {
            listItemClass: 'recently-viewed-card',
            showWishlist: true,
          });

        if (!window.JmpusProductCard.fetchRealCard) return Promise.resolve(fallback());

        return window.JmpusProductCard.fetchRealCard(item.url).then((node) => {
          if (!node) return fallback();
          const li = document.createElement('li');
          li.className = 'grid__item recently-viewed-card';
          li.appendChild(node);
          return li;
        });
      }
    }
  );
}
